export default {
  computed: {
    canI() {
      return this.$store.getters["brain/auth/canI"];
    },
  },
};
